import dayjs from "./dayjs";

const VN_TZ = "Asia/Ho_Chi_Minh";

/**
 * Chuẩn hoá ngày làm việc gửi lên BE (vd. GET /hrm/tasks/by-employee-date).
 * BE dùng so khớp t.work_day = $2 — nếu FE gửi ISO có Z có thể lệch ngày so với DATE trong DB.
 */
export function workDayToApiParam(workDay) {
  if (workDay == null || workDay === "") return "";
  const s = typeof workDay === "string" ? workDay.trim() : String(workDay);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const d = dayjs(workDay);
  if (!d.isValid()) return s.length >= 10 ? s.slice(0, 10) : s;
  return d.tz(VN_TZ).format("YYYY-MM-DD");
}
